module.exports = __webpack_public_path__ + "assets/img/5_1405_big.650ae195.jpg";